import useFetch, { muteErrorAndResult } from 'hooks/useFetch';
import { setUserHandle, getUser } from 'actions';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useAppDispatch } from 'store/hooks';
export const useEmmaEditTag = (defaultValue) => {
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const [, , isFetching, fetch] = useFetch(muteErrorAndResult);
    const handleSetTag = async (value) => {
        if (defaultValue === value) {
            navigation.goBack();
        }
        else if (!isFetching && !!value) {
            const result = await fetch(setUserHandle(value));
            if (result) {
                dispatch(getUser());
                navigation.goBack();
            }
        }
    };
    return {
        isFetching,
        handleSetTag,
    };
};
